module.exports = __webpack_public_path__ + "static/media/MIGORI.54364324.png";